import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './Sample.css';

function Sample({ name, width = 120 }) {
  let isFirst = true;
  const [launch, setLaunch] = useState(false);
  const play = () => {
    const player = document.getElementById(`sample_audio_${name}`);
    if (player) {
      if (!isFirst) {
        player.pause();
        player.currentTime = 0;
      }
      player.play();
      setLaunch(true);
      isFirst = false;
    }
    player.onended = () => { setLaunch(false) }
  }

  return (
    <div id={`sample ${name}`} onClick={play} className={`sample ${launch && `active`}`} style={{ width, height: 48, margin: 4, background: `#242424`, borderRadius: 2, color: `#A0A0A0`, display: `grid`, alignItems: `center`, textAlign: `center` }}>
      <audio preload="true" src={`${window.location.origin}/samples/${name}.flac`} id={`sample_audio_${name}`} />
      <span className={`sample-title`}>{name}</span>
    </div>
  )
}

Sample.propTypes = {
  name: PropTypes.string.isRequired,
  width: PropTypes.number,
  onClick: PropTypes.func
}

export default Sample;
